export default __webpack_public_path__ + "static/media/openssh-negative.aa2e886a.svg";